import styled from "styled-components";
import colors from "assets/scss/colors.scss";

const RadioCardOptionWrapper = styled.div`
  label.small {
    font-size: 0.85rem;
    font-weight: normal;
  }
  &.filled {
    display: flex;
    align-items: center;
    padding: 16px 24px;
    border-radius: 8px;
    background: #ffffff;
    border: 1px solid #d9dce1;
    flex-direction: row-reverse;
    justify-content: space-between;
    cursor: pointer;
    color:#1A1C1F;
    font-weight:bold;
    font-family:'tawuniya';
    svg{
        fill:#6B47F5;
    }
    &.active{
        background: #6B47F5;
        color:white;
        border:none;
        box-shadow: 0px 10px 20px rgba(238, 117, 0, 0.2);
        svg{
            fill:white;
        }

    }
    label {
      cursor: pointer;
    }
    .p-radiobutton .p-radiobutton-box .p-radiobutton-icon {
      width: 8px;
      height: 8px;
    }
    .p-radiobutton .p-radiobutton-box.p-highlight {
      border-color: #fff !important;
      background: #fff !important;
    }
    .p-radiobutton .p-radiobutton-box .p-radiobutton-icon {
      background: #000;
    }
  }

  &.outline {
    display: flex;
    align-items: center;
    padding: 14px 16px;
    box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
    border-radius: 4px;
    background: #ffffff;
    border: 1px solid #d9dce1;
    flex-direction: row-reverse;
    justify-content: space-between;
    cursor: pointer;
    color: #1a1c1f;
    font-weight: bold;
    font-family: "tawuniya";
    border: none;

    &.active {
      background: white;
      color: #000;
    }
    label {
      cursor: pointer;
    }
    .p-radiobutton .p-radiobutton-box .p-radiobutton-icon {
      width: 8px;
      height: 8px;
    }
    .p-radiobutton .p-radiobutton-box.p-highlight{
        border-color: ${props => `${props.businessColor} !important`};
        background: ${props => `${props.businessColor} !important`};
    }
    .p-radiobutton .p-radiobutton-box .p-radiobutton-icon {
      background: white;
    }
  }

  &.normal {
    display: flex;
    align-items: center;
    padding: 14px 16px;
    // box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
    border-radius: 4px;
    // background: #FFFFFF;
    border: 1px solid #d9dce1;
    cursor: pointer;
    color: #4C565C;
    font-family:'tawuniya';
    border:none;
    
    font-size:13px;
    &.active{
        // background: white;
        color:#000;

    font-size: 13px;
    &.active {
      // background: white;
      color: #000;
    }
    label {
      cursor: pointer;
      margin: 0 5px;
    }
    .p-radiobutton .p-radiobutton-box .p-radiobutton-icon {
      width: 8px;
      height: 8px;
    }
    .p-radiobutton .p-radiobutton-box.p-highlight{
      border-color: ${props => `${props.businessColor} !important`};
      background: ${props => `${props.businessColor} !important`};
    }
    .p-radiobutton .p-radiobutton-box .p-radiobutton-icon {
      background: white;
    }
  }
`;

export default RadioCardOptionWrapper;
